module.exports = __webpack_public_path__ + "static/img/wrinkles-01.55fa60d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/wrinkles-01.jpg
// module id = 301
// module chunks = 1